import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import 'babel-polyfill';
// import VueResource from 'vue-resource';
import VueCookies from 'vue-cookies';

import store from '@/store/index'
//iview
import ViewUI from 'view-design'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import weui from 'weui.js'
import VueI18n from 'vue-i18n'

import './utils/scanCode.js' // 扫码

// VuePrint
// import Print from 'vue-print-nb'
import Print from '@/utils/print';
Vue.use(Print)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
// import websocket from '../static/js/websocket'
import 'weui'
import axios from 'axios'
Vue.prototype.$axios = axios; //把axios挂载到vue的原型中，在vue中每个组件都可以使用axios发送请求
// Vue.prototype.HOME = '/api'
Vue.config.productionTip = false;

import en from 'element-ui/lib/locale/lang/en';
import zh_CN from 'element-ui/lib/locale/lang/zh-CN';
import vi from 'element-ui/lib/locale/lang/vi';
import Elelocale from 'element-ui/lib/locale' // 设置语言 

Elelocale.use(en)


//记得安装后需要使用起来!!!!!!!!!!
// Vue.use(VueResource)
Vue.use(VueCookies)

Vue.use(VueI18n);
const i18n = new VueI18n({
	locale: 'en',
	messages: {
		'zh': require('./VueI18n/language_zh'),
		'en': require('./VueI18n/language_en'),
		'vi': require('./VueI18n/language_vn')
	}
})

Vue.use(ViewUI)
Vue.use(iView)

//注册vuex
Vue.prototype.$store = store;
//注册全局weui
Vue.prototype.$weui = weui;
// Vue.prototype.$cookies = VueCookies;

import config from '@/utils/config';
import '@/assets/js/signalr.min.js';
var wsUrl = 'http://47.243.31.121:1000/signalr';
// 环境的切换
if (process.env.NODE_ENV === 'development') { // 开发
	wsUrl = config.devSignalrHost;
} else if (process.env.NODE_ENV === 'production') { //生产
	wsUrl = config.proSignalrHost;
} else if (process.env.NODE_ENV === 'release') { // 越南正式环境
	wsUrl = config.releaseSignalrHost;
} else if (process.env.NODE_ENV === 'tmkRelease') {
	wsUrl = config.tmkReleaseSignalrHost;
}
// const wsUrl = 'https://oaapi.tmi.com.vn/signalr';
var connection = new signalR.HubConnectionBuilder().withUrl(wsUrl).build();
connection.serverTimeoutInMilliseconds = 24e4;
connection.keepAliveIntervalInMilliseconds = 12e4;
Vue.prototype.$connection = connection;

Vue.prototype.$base64Img = (path) => { //图片转换base64  , 异步处理
	function getBase64Image(img) { //转码格式方法
		var canvas = document.createElement("canvas"); // 创建一个canvas
		canvas.width = img.width; // 设置对应的宽高
		canvas.height = img.height;
		var ctx = canvas.getContext("2d"); // 二维绘图环境
		ctx.drawImage(img, 0, 0, img.width, img.height); // 将图片画在画布上
		var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase(); // 获取到图片的格式
		var dataURL = canvas.toDataURL("image/" + ext); // 得到base64 编码的 dataURL 
		return dataURL;
	}
	return new Promise(function(resolve, reject) { //使用Promise进行异步处理
		let image = new Image();
		//解决图片跨域问题
		image.crossOrigin = '';
		//获取传入的图片路径
		image.src = path;
		//图片加载完后的回调函数,调用转码函数
		image.onload = function() {
			resolve(getBase64Image(image)) //回调函数返回base64值
		}
	})
}


Vue.use(ElementUI, {
	size: 'small'
});


// el-input格式化自定义指令
/**
 * @name inputFormatter
 * @msg: el-input格式化自定义指令
 * @param {Function} formatter 格式化函数
 * @param {Function} parser 解析函数
 * @param {Function} limit 输入限制函数
 * @param {Boolean} watchInput 是否监听input事件格式化显示
 * @param {Boolean} isNumber 是否为数字类型输入框（小数）
 * @returns 返回自定义指令生命周期函数
 */
const inputFormatter = ({
	formatter = (e) => e,
	parser = (e) => e,
	limit = (e) => e,
	watchInput = true,
	isNumber = false
}) => {
	return (el, binding, vnode) => {
		let watchVal = true
		const input = $(el).find(".el-input__inner")[0]
		// 获取记录光标位置
		let selectionSite
		let getSelectionSite = (event) => {
			let oldVal = event.target.value || ''
			let selectionStart = event.target.selectionStart
			selectionSite = oldVal.length - selectionStart
		}
		// 点击、键盘事件更新光标位置
		el.addEventListener("click", getSelectionSite)
		el.addEventListener("keyup", getSelectionSite)
		//为input绑定值赋值
		const assignment = (val) => {
			vnode.componentInstance.$emit('input', parser(val))
		}
		// 更改显示的值
		const upShow = (val) => {
			vnode.context.$nextTick(() => {
				input.value = val
			})
		}
		// 监听绑定值变化
		vnode.componentInstance.$watch('value', val => {
			if (watchVal) {
				upShow(formatter(val))
			}
		}, {
			deep: true,
			immediate: true
		})
		// 数字格式化
		let toNumber = (val) => {
			val = val.toString().replace(/[^\d^\.^\-]+/g, "") // 第二步：把不是数字，不是小数点、-的过滤掉
				.replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
				.replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
				.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".") // 只保留第一个".", 清除多余的"."
			// .match(/^\d*(\.?\d{0,9})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有1到9位小数
			return val
		}
		// 处理最后一位非法字符
		const handlerIllegalStr = (str) => {
			while (!(/^[0-9]+.?[0-9]*/.test(str.charAt(str.length - 1))) && str) {
				str = str.substr(0, str.length - 1)
			}
			return str || ''
		}
		// 监听input事件，可添加操作
		el.addEventListener("input", (event) => {
			let selectionStart = input.selectionStart
			let val = event.target.value
			if (binding.modifiers.number || isNumber) {
				val = toNumber(val)
			}
			let inp = limit(val)
			event.target.value = inp
			if (binding.modifiers.watchInput || watchInput) {
				assignment(inp)
				upShow(formatter(parser(val)))
			}
			setTimeout(() => {
				if (selectionSite && input.value.length != selectionStart) {
					input.selectionStart = input.selectionEnd = input.value.length -
						selectionSite
				}
			}, 0)
		})
		if (input) {
			input.addEventListener("blur", (event) => {
				watchVal = true
				let val = event.target.value;
				if (binding.modifiers.number || isNumber) {
					val = handlerIllegalStr(val)
				}
				assignment(val)
			})
			input.addEventListener("focus", (event) => {
				watchVal = false
			})
		}
	}
}

// 千分位指令
Vue.directive('thousands', {
	inserted: inputFormatter({
		// 格式化函数
		formatter(num) {
			if (!num && num !== 0) return '';
			num = num + '';
			let num1 = num.split(".")[0],
				num2 = num.split(".")[1];
			let c = num1.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
			return num.toString().indexOf(".") !== -1 ? c + "." + num2 : c;
		},
		// 解析函数
		parser(val) {
			val = val.toString().replace(/,/g, "")
			return val
		},
		isNumber: true
	})
});

// 百分比指令
Vue.directive('percentage', {
	inserted: inputFormatter({
		// 格式化函数
		formatter(val) {
			val = val.toString()
			let m = 0
			try {
				m = val.split(".")[1].length
			} catch (e) {}
			return Number(val.replace(".", "") * 100) / Math.pow(10, m)
		},
		// 解析函数
		parser(val) {
			val = val.toString()
			let l1 = 0,
				m
			try {
				l1 = val.split(".")[1].length;
			} catch (e) {}
			m = Math.pow(10, l1);
			return Number(val.replace(".", "")) / (100 * m);
		},
		watchInput: false,
		isNumber: true
	})
});

new Vue({
	i18n,
	router,
	store,
	render: h => h(App)
}).$mount('#app');


// WEBPACK FOOTER //
// ./src/main.js